export enum Sorting {
  Newest = 'NEWEST',
  TopRated = 'TOP_RATED',
  MostHelpful = 'MOST_HELPFUL',
  MostRelevant = 'MOST_RELEVANT',
}
